import { gql } from '@apollo/client';

// Documentos GraphQL de cupones (admin). Se consumen con los hooks useQuery/useMutation
// de Apollo en los componentes (mismo patrón que AdminSubscriptionsList).

export const COUPONS = gql`
  query Coupons($first: Int!, $page: Int, $search: String, $status: String) {
    coupons(first: $first, page: $page, search: $search, status: $status) {
      data {
        id
        code
        discount_type
        discount_value
        audience
        valid_from
        valid_to
        max_uses
        usage_count
        is_active
        plans { id name }
      }
      paginatorInfo { currentPage lastPage total }
    }
  }
`;

export const COUPON_USAGE = gql`
  query CouponUsage($coupon_id: ID, $created_at: DateRange) {
    couponUsage(coupon_id: $coupon_id, created_at: $created_at) {
      user_name
      user_email
      plan_name
      date
      amount
      discount
      currency
    }
  }
`;

export const CREATE_COUPON = gql`
  mutation CreateCoupon($input: CreateCouponInput!) {
    createCoupon(input: $input) {
      id
      code
    }
  }
`;

export const UPDATE_COUPON = gql`
  mutation UpdateCoupon($id: ID!, $input: UpdateCouponInput!) {
    updateCoupon(id: $id, input: $input) {
      id
      code
    }
  }
`;

export const DELETE_COUPONS = gql`
  mutation DeleteCoupons($id: [ID!]!) {
    deleteCoupons(id: $id) {
      id
    }
  }
`;

// Planes suscribibles para asociar al cupón (drag-and-drop).
export const SUBSCRIBABLE_PLANS = gql`
  query SubscribablePlans {
    plans(first: 100, page: 1) {
      data {
        id
        name
        price_cop
        subscription_interval
        is_subscribable
      }
    }
  }
`;
